import React, { useState, useEffect } from 'react';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import Modal, { ModalButton } from '../../../ui/Modal';

const inputStyle = {
  width: '100%', height: 40, padding: '0 12px',
  border: '1px solid rgba(56,47,42,0.18)', borderRadius: 8,
  fontFamily: 'inherit', fontSize: 13.5, background: '#fff', outline: 'none',
};

const ProductionDeliveryModal = ({ onClose, onConfirm, selectedOrders }) => {
  const [drivers, setDrivers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState('');
  const [selectedVehicle, setSelectedVehicle] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}v1/drivers`)
      .then(r => r.json()).then(d => setDrivers(Array.isArray(d) ? d : []))
      .catch(e => console.error(e));
    fetch(`${process.env.REACT_APP_API_URL}v1/vehicles`)
      .then(r => r.json()).then(d => setVehicles(Array.isArray(d) ? d : []))
      .catch(e => console.error(e));
  }, []);

  const handleConfirm = () => {
    if (!selectedDriver) { setError('Выберите экспедитора.'); return; }
    onConfirm({ driverId: selectedDriver, vehicleId: selectedVehicle || null, selectedOrders });
    onClose();
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Создать путевой лист"
      subtitle={`Заказов в пакете: ${selectedOrders?.length || 0}`}
      size="sm"
      footer={
        <>
          <ModalButton variant="ghost" onClick={onClose}>Отмена</ModalButton>
          <ModalButton variant="primary" onClick={handleConfirm}>
            <LocalShippingOutlinedIcon sx={{ fontSize: 18 }} />
            Создать
          </ModalButton>
        </>
      }
    >
      <div className="uimodal-field" style={{ gridTemplateColumns: '1fr' }}>
        <span className="uimodal-field__label">Экспедитор *</span>
        <select
          value={selectedDriver}
          onChange={(e) => { setSelectedDriver(e.target.value); setError(''); }}
          style={inputStyle}
        >
          <option value="">— выбрать —</option>
          {drivers.map(d => <option key={d.id} value={d.id}>{d.full_name}</option>)}
        </select>
      </div>
      <div className="uimodal-field" style={{ gridTemplateColumns: '1fr', marginTop: 12 }}>
        <span className="uimodal-field__label">Транспорт</span>
        <select
          value={selectedVehicle}
          onChange={(e) => setSelectedVehicle(e.target.value)}
          style={inputStyle}
        >
          <option value="">— не указан —</option>
          {vehicles.map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
        </select>
      </div>
      {error && (
        <div style={{
          marginTop: 12, padding: '10px 12px',
          background: 'rgba(220,77,69,0.08)',
          border: '1px solid rgba(220,77,69,0.25)',
          color: '#B73C36', borderRadius: 8, fontSize: 13,
        }}>{error}</div>
      )}
    </Modal>
  );
};

export default ProductionDeliveryModal;
